import React, { useMemo } from 'react'
import { Helmet } from 'components/UI'
import TwoFactor from 'components/apps/User/Login/TwoFactorRequired'
import { decodeUriWithAtob } from 'utils/helper'

// NOTE: Jangan mendestructure data yang biasanya ada di pages yang digunakan di routes
// Karena file ini juga digunakan di login yang pakai modal -> src/pages/user/login/LoginModal.jsx
const TwoFactorRequired = ({ match, email, isOnModal, isTemporary }) => {
  const { params = {} } = match ?? {}
  const _params = useMemo(() => {
    return decodeUriWithAtob(params?.data, false)
  }, [params])

  return (
    <>
      <Helmet title="Two Factor Required" />
      <TwoFactor
        email={email || _params?.email}
        isOnModal={isOnModal}
        isTemporary={isTemporary || `${_params?.temporary}` === '1'}
      />
    </>
  )
}

export default TwoFactorRequired
